import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  template: `
     <form [formGroup]="formEdit" >
      <mat-dialog-content>
          <h1 class="descContent"> {{info}}</h1>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button mat-raised-button  (click)="close()">OK</button>
      </mat-dialog-actions>
    </form>
  `,
  styleUrls: ['./confirm-dialog.component.css']
})

export class ConfirmDialogComponent implements OnInit {
  formEdit: FormGroup;
  info = '';
  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<ConfirmDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data) {
                this.info = data.content ;
   }

  ngOnInit(): void {
    this.formEdit = this.formBuilder.group({});
  }
  close() {
    this.dialogRef.close();
  }
}




